import React from "react";
import { Segment, Message, Icon, Header, Form } from "semantic-ui-react";
import { Field } from "redux-form";

function renderTextField({
  input,
  meta: { touched, error, warning },
  ...others
}) {
  let color = touched && ((error && "red") || (warning && "yellow"));
  let mensaje =
    touched &&
    ((error && <span>{error}</span>) || (warning && <span>{warning}</span>));

  return (
    <React.Fragment>
      <Form.Input {...input} {...others} />
      {touched &&
        ((error || warning) && (
          <Message negative>
            <Message.Header>
              <Icon
                name="warning circle"
                style={{
                  color
                }}
              />
              {mensaje}
            </Message.Header>
          </Message>
        ))}
    </React.Fragment>
  );
}

const required = value => (value ? undefined : "Requerido");

function DatosPersonales(props) {
  return (
    <Segment>
      <Header as="h3">Datos del niño / niña</Header>

      <label>
        <strong>Nombre</strong>
      </label>
      <Field
        id="nombre"
        name="nombre"
        type="text"
        component={renderTextField}
        validate={[required]}
      />

      <label>
        <strong>Apellidos</strong>
      </label>
      <Field
        id="apellido1"
        name="apellido1"
        type="text"
        component={renderTextField}
        validate={[required]}
      />

      <label>
        <strong>Fecha de Nacimiento</strong>
      </label>
      <Field
        id="nacimiento"
        name="nacimiento"
        type="date"
        component={renderTextField}
        validate={[required]}
      />

      <label>
        <strong>Curso</strong>
      </label>
      <Field
        id="curso"
        name="curso"
        type="text"
        component={renderTextField}
        validate={[required]}
      />

      <label>
        <strong>Colegio de procedencia</strong>
      </label>
      <Field
        id="colegioProcedencia"
        name="colegioProcedencia"
        type="text"
        component={renderTextField}
        validate={[required]}
      />

      <div>
        <label style={{ cursor: "pointer" }} htmlFor="hermano">
          <Field
            id="hermano"
            name="hermano"
            type="checkbox"
            component="input"
          />
          {" ¿Es el segundo o tercer hermano en la escuela?"}
        </label>
      </div>
      <label>
        10€ descuento al segundo y tercer hermano cuando se contrate ESCUELA
        COMPLETA O MES
      </label>
    </Segment>
  );
}

export default DatosPersonales;



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/hojaPreinscripcion/formularioInscripcion/DatosPersonales.jsx